import { render, staticRenderFns } from "./MenuEditPage.vue?vue&type=template&id=be38ab4e&scoped=true&"
import script from "./MenuEditPage.vue?vue&type=script&lang=js&"
export * from "./MenuEditPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuEditPage.vue?vue&type=style&index=0&id=be38ab4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be38ab4e",
  null
  
)

export default component.exports